import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc';

import Photo from './Photo';

function hasPhotos(photos) {
  if (!photos) {
    return false;
  }
  if (Object.prototype.hasOwnProperty.call(photos, 'length')) {
    return photos.length !== 0;
  }
  return false;
}

function photosLength(photos) {
  if (!photos) {
    return 0;
  }
  if (Object.prototype.hasOwnProperty.call(photos, 'length')) {
    return photos.length;
  }
  return 0;
}

const SortableItem = SortableElement(({ value }) =>
  <div>{value}</div>,
);
const SortableList = SortableContainer(({ items }) => {
  const wrappedList = items.map((value, index) => (
    <SortableItem key={`item-${index}`} index={index} value={value} />
  ));
  return (
    <div>
      {wrappedList}
    </div>
  );
});

class PhotosForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      photos: props.hotel.photos,
    };
    this.onDrop = this.onDrop.bind(this);
    this.onSortEnd = this.onSortEnd.bind(this);
  }
  componentWillReceiveProps(nextProps) {
  //  if (this.props.hotel.photos !== nextProps.hotel.photos) {
    this.setState({
      photos: nextProps.hotel.photos,
    });
    //}
  }
  onDrop(acceptedFiles) {
    this.setState({
      files: acceptedFiles,
    });
    const payload = {
      hotel: this.props.hotel.id,
      order: photosLength(this.props.hotel.photos) * 1000,
      files: acceptedFiles,
    };
    this.props.addHotelPhoto(payload);
  }
  onSortEnd({ oldIndex, newIndex }) {
    if (oldIndex !== newIndex) {
      const p = this.state.photos[oldIndex];
      const payload = {
        photo: p.id,
        old: oldIndex,
        new: newIndex,
      };
      this.props.sortHotelPhotos(this.props.hotel.id, payload);
      this.setState({
        photos: arrayMove(this.state.photos, oldIndex, newIndex),
      });
    }
  }
  renderPhotos(photos) {
    if (hasPhotos(photos)) {
      const photoList = photos.map((photo) => {
        return (<Photo
          key={photo.id}
          photo={photo}
          removeHotelPhoto={this.props.removeHotelPhoto}
          editHotelPhoto={this.props.editHotelPhoto}
        />);
      });
      return <SortableList items={photoList} onSortEnd={this.onSortEnd} distance={10} />;
    }
    return (
      <div className="col-md-12">
        <h4 className="hotel-highlight">No photos available</h4>
      </div>
    );
  }

  render() {
    const photos = this.renderPhotos(this.state.photos);
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <h1 className="hotel-detail-subhead">Upload Photos{' '}
              <Button onClick={this.props.handleClose}>Done</Button>
            </h1>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <p>
              Include a range of images such as exteriors, bedrooms, lobby,
              pools and other attractions.
              <br />
              Photos should not include offensive images, copyright markings,
              text, logos, borders, and maps.
              <br />
            </p>
            <Dropzone
              ref={(node) => { this.dropzone = node; }}
              onDrop={this.onDrop}
              accept="image/*"
              className="hotel-drop"
              rejectClassName="hotel-drop-reject"
            >
              <div className="hotel-drop-inner">
                <h1>
                  <i className="fa fa-cloud-upload" aria-hidden="true" />
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  Drag here or <span className="hotel-drop-click">browse</span> to upload
                </h1>
              </div>
            </Dropzone>
          </div>
        </div>
        <div className="row">
          { photos }
        </div>
      </div>
    );
  }
}
PhotosForm.propTypes = {
  hotel: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  addHotelPhoto: PropTypes.func.isRequired,
  editHotelPhoto: PropTypes.func.isRequired,
  removeHotelPhoto: PropTypes.func.isRequired,
  sortHotelPhotos: PropTypes.func.isRequired,
};
PhotosForm.defaultTypes = {
  photos: [],
};
export default PhotosForm;



// WEBPACK FOOTER //
// src/routes/hotels/components/PhotosForm.js